import types from '../actions/types';
import produce from 'immer';
import _indexOf from 'lodash/indexOf';
import _remove from 'lodash/remove';

// const initialState = {
//   show: true,
//   selected: ['3a017fc5-4f50-4db9-b0ce-4547ba0a1bfd']
// };

const initialState = {
  show: false,
  selected: []
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    // case types.ADD_NEW_TEXT_OBJECT:
    //   return produce(state, draftState => {
    //     draftState.selected = [action.payload.uuid];
    //   });
    case types.SELECT_OBJECT:
      return {
        ...state,
        selected: [action.payload.id]
      };
    case types.SELECT_OBJECT_MULTIPLE:
      return produce(state, draftState => {
        if (_indexOf(state.selected, action.payload.id) === -1) {
          draftState.selected.push(action.payload.id);
        } else {
          _remove(draftState.selected, (n) => n === action.payload.id);
        }
      });
    case types.DESELECT_OBJECTS:
    case types.DELETE_OBJECT:
      return {
        ...state,
        selected: []
      };
    case types.TOGGLE_LAYERS:
      return produce(state, draftState => {
        draftState.show = !draftState.show;
      });
    case types.SHOW_LAYERS:
      return {
        ...state,
        show: true
      };
    case types.HIDE_LAYERS:
      return {
        ...state,
        hide: true
      };
    case types.ADD_NEW_TEMPLATE_TEXT:
      return {
        ...state,
        selected: [action.payload.uuid]
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/layersReducer.js